models.service('QuestionModel', ['constants', function (Constants) {
    function Question(rawQuestion, translation) {
        var self = this;
        self.translation = translation;

        self.id = rawQuestion.id;
        self.label = self.translation.questionnarie_questions[rawQuestion.id.toString()] || rawQuestion.title;
        self.allowOther = !!rawQuestion.free;
        self.onlyOther = false;
        self.isCountryAnswers = false;
        self.isMulti = !!rawQuestion.multi;
        self.formModelName = 'question-' + self.id;
        self.other = "";
        self.answers = rawQuestion.answers.map(function (rawAnswer) {
            var isSelected = rawQuestion.values.indexOf(rawAnswer) >= 0;
            return formatAnswer(rawAnswer, isSelected);
        });


        var multiValues = rawQuestion.values.map(function (rawAnswer) {
            return formatAnswer(rawAnswer)
        });
        var singleValue = rawQuestion.values.length > 0
            ? formatAnswer(rawQuestion.values[0])
            : '';

        self.values = self.isMulti ? multiValues : singleValue;

        if (!self.answers.length && self.allowOther) {
            self.onlyOther = true;
        }

        if (self.allowOther) {
            self.other = rawQuestion.other;
            self.answers.push(formatAnswer(-1, self.other.length > 0));

            if (Array.isArray(self.values) && self.other.length > 0) {
                self.values.push(formatAnswer(-1));
            }
        }

        if (self.answers.length > 100 && !self.allowOther) {
            self.isCountryAnswers = true;
        }

        self.group = rawQuestion.group;
        self.parentAnswers = rawQuestion.parentAnswers || [];
        self.valid = false;

        function formatAnswer(answerId, selected) {
            var labelTranslationKey = Constants['questionnaireAnswersOverrides']
                && Constants['questionnaireAnswersOverrides'][self.id]
                && Constants['questionnaireAnswersOverrides'][self.id][answerId];

            var label = (self.translation && (self.translation[labelTranslationKey] || self.translation.questionnarie_answers[answerId.toString()]))
                || answerId.toString();
            return {
                id: answerId.toString(),
                label: label,
                _selected: selected
            }
        }

        self.formatAnswer = formatAnswer;

    }

    return Question;
}]);
